import { render, staticRenderFns } from "./AnomProbBl.vue?vue&type=template&id=667423a8&scoped=true&"
import script from "./AnomProbBl.vue?vue&type=script&lang=js&"
export * from "./AnomProbBl.vue?vue&type=script&lang=js&"
import style0 from "./AnomProbBl.vue?vue&type=style&index=0&id=667423a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667423a8",
  null
  
)

/* custom blocks */
import block0 from "./AnomProbBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports